import React, { useState, useRef } from 'react';
import { Header } from './Header';
import { Problem } from './Problem';
import { Solution } from './Solution';
import { Testimonials } from './Testimonials';
import { Reviews } from './Reviews';
import { WebinarDetails } from './WebinarDetails';
import { FAQ } from './FAQ';
import { Benefits } from './Benefits';
import { CallToAction } from './CallToAction';
import { MoreTestimonials } from './MoreTestimonials';
import { Footer } from './Footer';
import { WebinarModal } from './WebinarModal';
import { FacebookPixel } from './FacebookPixel';
import { GoogleTag } from './GoogleTag';
import { StickyButton } from './StickyButton';
export const Advertorial = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const stickyButtonRef = useRef<HTMLHeadingElement>(null);
  const openModal = () => {
    window.location.href = 'https://stresslessdogs.nl/mcc-gsearch-adv2';
  };
  const closeModal = () => setIsModalOpen(false);
  return <div className="max-w-3xl mx-auto px-4 py-6 font-sans text-gray-800" data-id="element-6">
      <FacebookPixel data-id="element-7" />
      <GoogleTag data-id="element-8" />
      <WebinarModal isOpen={isModalOpen} onClose={closeModal} data-id="element-9" />
      <Header openModal={openModal} data-id="element-10" />
      <Problem openModal={openModal} data-id="element-11" />
      <Solution openModal={openModal} data-id="element-12" />
      <Testimonials openModal={openModal} stickyButtonRef={stickyButtonRef} data-id="element-13" />
      <WebinarDetails openModal={openModal} data-id="element-14" />
      <Reviews data-id="element-15" />
      <FAQ openModal={openModal} data-id="element-16" />
      <Benefits openModal={openModal} data-id="element-17" />
      <CallToAction openModal={openModal} data-id="element-18" />
      <MoreTestimonials data-id="element-19" />
      <Footer openModal={openModal} data-id="element-20" />
      <StickyButton targetRef={stickyButtonRef} onClick={openModal} data-id="element-21" />
    </div>;
};